import request from '@/common/utils/request'
// 获取优惠券
export function getCouonp (data) {
  return request({
    url: process.env.HTTP_SERVER + 'v1/coupon/queryById',
    method: 'get',
    params: {
      ...data
    }
  })
}
// 获取天数
export function getDay (data) {
  return request({
    url: process.env.HTTP_question_SERVER + 'auth/v2/survey/queryrank',
    // url: 'http://10.10.30.104:8127/v1/survey/queryConfigByToken',
    method: 'get',
    params: {
      ...data
    }
  })
}
// 用户提交
export function singUp (data) {
  return request({
    url: process.env.HTTP_question_SERVER + 'auth/v2/survey/saveuserinfo',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/data/api/experince.js